export default "__VITE_ASSET__DySH_Jnd__"